/* Scroll reveal — fade-and-rise sections as they enter the viewport.
   Respects prefers-reduced-motion. Applies to top-level sections in <main>. */
(function () {
  const script = document.currentScript;
  const enabled = !script || script.dataset.enabled !== 'false';
  const reduceMotion = script && script.dataset.reduceMotion === 'true';
  if (!enabled || reduceMotion) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const sections = document.querySelectorAll('main > .shopify-section');
  if (!sections.length) return;

  sections.forEach((el) => el.classList.add('reveal'));

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal--visible');
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

  sections.forEach((el) => io.observe(el));
})();
